import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const inventoryType = [
    {
        ID: 'I',
        Text: 'Inventory'
    }
]
const statusType = [
    {
        ID: 'O',
        Text: 'Open'
    },
    {
        ID: 'H',
        Text: 'Hold'
    },
    {
        ID: 'L',
        Text: 'Ready To Commit Later'
    }
]
const OpenPosReceiptTabResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "bd3526a6-968e-4e32-8623-102d96684613";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="vendorID" caption='Vendor' ></Column>
                <Column dataField="referenceNumber" caption='PO Number' ></Column>
                <Column dataField="lotCode" caption='Lot' ></Column>
                <Column dataField="receivedQuantity" dataType="number" caption='Received'
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true // Use this to include thousand separators
                    }} ></Column>
                <Column dataField="orderedQuantity" caption='Back Ordered' dataType="number"
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true // Use this to include thousand separators
                    }} ></Column>
                <Column dataField="unitCostOriginal" caption='Unit Price' dataType="number"
                    format={{
                        type: 'currency',
                        precision: 2,
                        currency: 'USD',
                        useGrouping: true // Use this to include thousand separators
                    }}></Column>

                <Column dataField="invoiceNumber" caption='Invoice #' ></Column>
                <Column dataField="dateReceived" caption='Received Date' dataType="date"></Column>
                <Column dataField="duedate" caption='Due Date' dataType="date"></Column>

                <Column dataField="type" caption="Type" visible={false}
                    lookup={{ dataSource: inventoryType, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'I':
                                return <span>Inventory</span>;
                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}></Column>
                <Column dataField="vendorName" caption="Vendor Name" visible={false}></Column>
                <Column dataField="account" caption="Account" visible={false}></Column>
                <Column dataField="accountDesc" caption="Account Desc" visible={false}></Column>
                <Column dataField="activity" caption="Activity" visible={false}></Column>
                <Column dataField="activityDesc" caption="Activity Desc" visible={false}></Column>

                <Column dataField="status" caption="Status" visible={false}
                    lookup={{ dataSource: statusType, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                        switch (cellData.value) {
                            case 'O':
                                return <span>Open</span>;
                            case 'L':
                                return <span>Ready To Commit Later</span>;
                            case 'H':
                                return <span>Hold</span>;

                            default:
                                return <span>{cellData.value}</span>;
                        }
                    }}></Column>

                <Column dataField="priceLevelA" caption='Price Level A' dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>
                <Column dataField="priceLevelB" caption='Price Level B' dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>
                <Column dataField="priceLevelC" caption='Price Level C' dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>
                <Column dataField="priceLevelD" caption='Price Level D' dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>
                <Column dataField="priceLevelE" caption='Price Level E' dataType="number" visible={false}
                    format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true
                    }} ></Column>

                <Column dataField="taxableflag" caption="Taxable Flag" visible={false}></Column>
                <Column dataField="expirationdate" caption="Expiration Date" dataType="date" visible={false}></Column>
                <Column dataField="daterequired" caption="Date Required" dataType="date" visible={false}></Column>
                <Column dataField="dateexpected" caption="Date Expected" dataType="date" visible={false}></Column>
                <Column dataField="datereceived" caption="Date Received" dataType="date" visible={false}></Column>
                <Column dataField="unitofmeasure" caption="Unit of Measure" visible={false}></Column>
                <Column dataField="comment" caption="Comment" visible={false}></Column>
                <Column dataField="referencenumber" caption="Reference Number" visible={false}></Column>

                <Column dataField="orderedquantity" caption="Ordered Quantity" visible={false}></Column>
                <Column dataField="backorderquantity" caption="Backorder Quantity" visible={false}></Column>
                <Column dataField="receivedquantity" caption="Received Quantity" visible={false}></Column>
                <Column dataField="userdefinedcomment" caption="User Defined Comment" visible={false}></Column>

                <Column dataField="noninvitemdescription" caption="Non-Inventory Item Description" visible={false}></Column>
                <Column dataField="sourcetablename" caption="Source Table Name" visible={false}></Column>
                <Column dataField="orderdate" caption="Order Date" dataType="date" visible={false}></Column>
                <Column dataField="purposecomment" caption="Purpose Comment" visible={false}></Column>
                <Column dataField="foreignunitcost" caption="Foreign Unit Cost" visible={false}></Column>
                <Column dataField="foreignamount" caption="Foreign Amount" visible={false}></Column>
                <Column dataField="feetype" caption="Fee Type" visible={false}></Column>
                <Column dataField="componentcostdiscount" caption="Component Cost Discount" visible={false}></Column>

                <Column dataField="code1_Detail" caption="Code1 - Detail" visible={false}></Column>
                <Column dataField="code2_Detail" caption="Code2 - Detail" visible={false}></Column>
                <Column dataField="code3_Detail" caption="Code3 - Detail" visible={false}></Column>
                <Column dataField="code4_Detail" caption="Code4 - Detail" visible={false}></Column>
                <Column dataField="code5_Detail" caption="Code5 - Detail" visible={false}></Column>

                <Column dataField="code1_Header" caption="Code1 - Receipt Header" visible={false}></Column>
                <Column dataField="code2_Header" caption="Code2 - Receipt Header" visible={false}></Column>
                <Column dataField="code3_Header" caption="Code3 - Receipt Header" visible={false}></Column>
                <Column dataField="code4_Header" caption="Code4 - Receipt Header" visible={false}></Column>
                <Column dataField="code5_Header" caption="Code5 - Receipt Header" visible={false}></Column>
                <Column dataField="code6_Header" caption="Code6 - Receipt Header" visible={false}></Column>
                <Column dataField="code7_Header" caption="Code7 - Receipt Header" visible={false}></Column>
                <Column dataField="code8_Header" caption="Code8 - Receipt Header" visible={false}></Column>
                <Column dataField="code9_Header" caption="Code9 - Receipt Header" visible={false}></Column>
                <Column dataField="code10_Header" caption="Code10 - Receipt Header" visible={false}></Column>

                <Column dataField="code1_Lot" caption="Code1 - Lot" visible={false}></Column>
                <Column dataField="code2_Lot" caption="Code2 - Lot" visible={false}></Column>
                <Column dataField="code3_Lot" caption="Code3 - Lot" visible={false}></Column>
                <Column dataField="code4_Lot" caption="Code4 - Lot" visible={false}></Column>
                <Column dataField="code5_Lot" caption="Code5 - Lot" visible={false}></Column>
                <Column dataField="code6_Lot" caption="Code6 - Lot" visible={false}></Column>
                <Column dataField="code7_Lot" caption="Code7 - Lot" visible={false}></Column>
                <Column dataField="code8_Lot" caption="Code8 - Lot" visible={false}></Column>
                <Column dataField="code9_Lot" caption="Code9 - Lot" visible={false}></Column>
                <Column dataField="code10_Lot" caption="Code10 - Lot" visible={false}></Column>

                <Column dataField="date1_Detail" caption="Date1 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date2_Detail" caption="Date2 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date3_Detail" caption="Date3 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date4_Detail" caption="Date4 _ Detail" dataType="date" visible={false}></Column>
                <Column dataField="date5_Detail" caption="Date5 _ Detail" dataType="date" visible={false}></Column>

                <Column dataField="date1_Lot" caption="Date1 _ Lot" dataType="date" visible={false}></Column>
                <Column dataField="date2_Lot" caption="Date2 _ Lot" dataType="date" visible={false}></Column>
                <Column dataField="date3_Lot" caption="Date3 _ Lot" dataType="date" visible={false}></Column>
                <Column dataField="date4_Lot" caption="Date4 _ Lot" dataType="date" visible={false}></Column>
                <Column dataField="date5_Lot" caption="Date5 _ Lot" dataType="date" visible={false}></Column>
                <Column dataField="date6_Lot" caption="Date6 _ Lot" dataType="date" visible={false}></Column>
                <Column dataField="date7_Lot" caption="Date7 _ Lot" dataType="date" visible={false}></Column>
                <Column dataField="date8_Lot" caption="Date8 _ Lot" dataType="date" visible={false}></Column>
                <Column dataField="date9_Lot" caption="Date9 _ Lot" dataType="date" visible={false}></Column>
                <Column dataField="date10_Lot" caption="Date10 Lot" dataType="date" visible={false}></Column>

                <Column dataField="date1_Header" caption="Date1 _ Receipt Header" dataType="date" visible={false}></Column>
                <Column dataField="date2_Header" caption="Date2 _ Receipt Header" dataType="date" visible={false}></Column>
                <Column dataField="date3_Header" caption="Date3 _ Receipt Header" dataType="date" visible={false}></Column>
                <Column dataField="date4_Header" caption="Date4 _ Receipt Header" dataType="date" visible={false}></Column>
                <Column dataField="date5_Header" caption="Date5 _ Receipt Header" dataType="date" visible={false}></Column>
                <Column dataField="date6_Header" caption="Date6 _ Receipt Header" dataType="date" visible={false}></Column>
                <Column dataField="date7_Header" caption="Date7 _ Receipt Header" dataType="date" visible={false}></Column>
                <Column dataField="date8_Header" caption="Date8 _ Receipt Header" dataType="date" visible={false}></Column>
                <Column dataField="date9_Header" caption="Date9 _ Receipt Header" dataType="date" visible={false}></Column>
                <Column dataField="date10_Header" caption="Date10 _ Receipt Header" dataType="date" visible={false}></Column>

                <Column dataField="quantity1_Detail" caption="Quantity1 _ Detail" visible={false}></Column>
                <Column dataField="quantity2_Detail" caption="Quantity2 _ Detail" visible={false}></Column>
                <Column dataField="quantity3_Detail" caption="Quantity3 _ Detail" visible={false}></Column>
                <Column dataField="quantity4_Detail" caption="Quantity4 _ Detail" visible={false}></Column>
                <Column dataField="quantity5_Detail" caption="Quantity5 _ Detail" visible={false}></Column>

                <Column dataField="quantity1_Header" caption="Quantity1 _ Receipt Header" visible={false}></Column>
                <Column dataField="quantity2_Header" caption="Quantity2 _ Receipt Header" visible={false}></Column>
                <Column dataField="quantity3_Header" caption="Quantity3 _ Receipt Header" visible={false}></Column>
                <Column dataField="quantity4_Header" caption="Quantity4 _ Receipt Header" visible={false}></Column>
                <Column dataField="quantity5_Header" caption="Quantity5 _ Receipt Header" visible={false}></Column>
                <Column dataField="quantity6_Header" caption="Quantity6 _ Receipt Header" visible={false}></Column>
                <Column dataField="quantity7_Header" caption="Quantity7 _ Receipt Header" visible={false}></Column>
                <Column dataField="quantity8_Header" caption="Quantity8 _ Receipt Header" visible={false}></Column>
                <Column dataField="quantity9_Header" caption="Quantity9 _ Receipt Header" visible={false}></Column>
                <Column dataField="quantity10_Header" caption="Quantity10 _ Receipt Header" visible={false}></Column>


                <Column dataField="quantity1_Lot" caption="Quantity1 _ Lot Header" visible={false}></Column>
                <Column dataField="quantity2_Lot" caption="Quantity2 _ Lot Header" visible={false}></Column>
                <Column dataField="quantity3_Lot" caption="Quantity3 _ Lot Header" visible={false}></Column>
                <Column dataField="quantity4_Lot" caption="Quantity4 _ Lot Header" visible={false}></Column>
                <Column dataField="quantity5_Lot" caption="Quantity5 _ Lot Header" visible={false}></Column>
                <Column dataField="quantity6_Lot" caption="Quantity6 _ Lot Header" visible={false}></Column>
                <Column dataField="quantity7_Lot" caption="Quantity7 _ Lot Header" visible={false}></Column>
                <Column dataField="quantity8_Lot" caption="Quantity8 _ Lot Header" visible={false}></Column>
                <Column dataField="quantity9_Lot" caption="Quantity9 _ Lot Header" visible={false}></Column>
                <Column dataField="quantity10_Lot" caption="Quantity10 _ Lot Header" visible={false}></Column>

                <Column dataField="reference1_Detail" caption="Reference1 _ Detail" visible={false}></Column>
                <Column dataField="reference2_Detail" caption="Reference2 _ Detail" visible={false}></Column>
                <Column dataField="reference3_Detail" caption="Reference3 _ Detail" visible={false}></Column>
                <Column dataField="reference4_Detail" caption="Reference4 _ Detail" visible={false}></Column>
                <Column dataField="reference5_Detail" caption="Reference5 _ Detail" visible={false}></Column>

                <Column dataField="reference1_Header" caption="Reference1 _ Receipt Header" visible={false}></Column>
                <Column dataField="reference2_Header" caption="Reference2 _ Receipt Header" visible={false}></Column>
                <Column dataField="reference3_Header" caption="Reference3 _ Receipt Header" visible={false}></Column>
                <Column dataField="reference4_Header" caption="Reference4 _ Receipt Header" visible={false}></Column>
                <Column dataField="reference5_Header" caption="Reference5 _ Receipt Header" visible={false}></Column>
                <Column dataField="reference6_Header" caption="Reference6 _ Receipt Header" visible={false}></Column>
                <Column dataField="reference7_Header" caption="Reference7 _ Receipt Header" visible={false}></Column>
                <Column dataField="reference8_Header" caption="Reference8 _ Receipt Header" visible={false}></Column>
                <Column dataField="reference9_Header" caption="Reference9 _ Receipt Header" visible={false}></Column>
                <Column dataField="reference10_Header" caption="Reference10 _ Receipt Header" visible={false}></Column>

                <Column dataField="reference1_Lot" caption="Reference1 _ Lot Header" visible={false}></Column>
                <Column dataField="reference2_Lot" caption="Reference2 _ Lot Header" visible={false}></Column>
                <Column dataField="reference3_Lot" caption="Reference3 _ Lot Header" visible={false}></Column>
                <Column dataField="reference4_Lot" caption="Reference4 _ Lot Header" visible={false}></Column>
                <Column dataField="reference5_Lot" caption="Reference5 _ Lot Header" visible={false}></Column>
                <Column dataField="reference6_Lot" caption="Reference6 _ Lot Header" visible={false}></Column>
                <Column dataField="reference7_Lot" caption="Reference7 _ Lot Header" visible={false}></Column>
                <Column dataField="reference8_Lot" caption="Reference8 _ Lot Header" visible={false}></Column>
                <Column dataField="reference9_Lot" caption="Reference9 _ Lot Header" visible={false}></Column>
                <Column dataField="reference10_Lot" caption="Reference10 _ Lot Header" visible={false}></Column>

                <Toolbar>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(OpenPosReceiptTabResult);